export enum CurrencyErrorTypeEnum {
  MIN = "min",
  MAX = "max",
}
